export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/locationPin.db278cf1.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};